import { render, staticRenderFns } from "./StepsCarousel.vue?vue&type=template&id=1afdcfd4&scoped=true&"
import script from "./StepsCarousel.vue?vue&type=script&lang=js&"
export * from "./StepsCarousel.vue?vue&type=script&lang=js&"
import style0 from "./StepsCarousel.vue?vue&type=style&index=0&id=1afdcfd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1afdcfd4",
  null
  
)

export default component.exports